import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"

export interface SelectedCDDataAdmin {
  id: string
  key?: string
  startDate?: string
  endDate?: string
  frameworkType?: 0 | 1 | 2 | 3
  frameworkTypeDescription?: "None" | "ObjectiveLed" | "PersonCentered" | "BalancedScorecard"
}

export interface SelectedCDDataEmp {
  id: string
  key?: string
  frameworkType?: 0 | 1 | 2 | 3
  frameworkTypeDescription?: "None" | "ObjectiveLed" | "PersonCentered" | "BalancedScorecard"
}

interface CycleDurationAdminState {
  selectedCDData: SelectedCDDataAdmin
  setSelectedCDData: (
    data:
      | SelectedCDDataAdmin
      | ((prev: SelectedCDDataAdmin) => SelectedCDDataAdmin)
  ) => void
  resetCDData: () => void
}

interface CycleDurationEmpState {
  selectedCDData: SelectedCDDataEmp
  setSelectedCDData: (
    data: SelectedCDDataEmp | ((prev: SelectedCDDataEmp) => SelectedCDDataEmp)
  ) => void
  resetCDData: () => void
}

const defaultAdminData: SelectedCDDataAdmin = {
  id: "",
  key: "",
  startDate: "",
  endDate: "",
  frameworkType: 1,
  frameworkTypeDescription: "ObjectiveLed",
}

const defaultEmpData: SelectedCDDataEmp = {
  id: "",
  key: "",
  frameworkType: 1,
  frameworkTypeDescription: "ObjectiveLed",
}

export const useCycleDurationAdminStore = create<CycleDurationAdminState>()(
  persist(
    (set) => ({
      selectedCDData: defaultAdminData,
      setSelectedCDData: (data) =>
        set((state) => ({
          selectedCDData:
            typeof data === "function" ? data(state.selectedCDData) : data,
        })),
      resetCDData: () => set({ selectedCDData: defaultAdminData }),
    }),
    {
      name: "cycle-duration-admin",
      // storage: {
      //   getItem: (name) => {
      //     const value = sessionStorage.getItem(name)
      //     return value ? JSON.parse(value) : null
      //   },
      //   setItem: (name, value) => {
      //     sessionStorage.setItem(name, JSON.stringify(value))
      //   },
      //   removeItem: (name) => {
      //     sessionStorage.removeItem(name)
      //   },
      // },
    }
  )
)

export const useCycleDurationEmpStore = create<CycleDurationEmpState>()(
  persist(
    (set) => ({
      selectedCDData: defaultEmpData,
      setSelectedCDData: (data) =>
        set((state) => ({
          selectedCDData:
            typeof data === "function" ? data(state.selectedCDData) : data,
        })),
      resetCDData: () => set({ selectedCDData: defaultEmpData }),
    }),
    {
      name: "cycle-duration-emp",
      // storage: {
      //   getItem: (name) => {
      //     const value = sessionStorage.getItem(name)
      //     return value ? JSON.parse(value) : null
      //   },
      //   setItem: (name, value) => {
      //     sessionStorage.setItem(name, JSON.stringify(value))
      //   },
      //   removeItem: (name) => {
      //     sessionStorage.removeItem(name)
      //   },
      // },
    }
  )
)

export const useCycleDurationManagerStore = create<CycleDurationEmpState>()(
  persist(
    (set) => ({
      selectedCDData: defaultEmpData,
      setSelectedCDData: (data) =>
        set((state) => ({
          selectedCDData:
            typeof data === "function" ? data(state.selectedCDData) : data,
        })),
      resetCDData: () => set({ selectedCDData: defaultEmpData }),
    }),
    {
      name: "cycle-duration-manager",
      // storage: {
      //   getItem: (name) => {
      //     const value = sessionStorage.getItem(name)
      //     return value ? JSON.parse(value) : null
      //   },
      //   setItem: (name, value) => {
      //     sessionStorage.setItem(name, JSON.stringify(value))
      //   },
      //   removeItem: (name) => {
      //     sessionStorage.removeItem(name)
      //   },
      // },
    }
  )
)

export const useCycleDurationAdminID = () =>
  useCycleDurationAdminStore((state) => state.selectedCDData?.id)

export const useCycleDurationEmpID = () =>
  useCycleDurationEmpStore((state) => state.selectedCDData?.id)

export const useCycleDurationManagerID = () =>
  useCycleDurationManagerStore((state) => state.selectedCDData?.id)

/**
 * Use this only when `type` is a dynamic prop/value that can't be statically
 * known at the call site. For static cases prefer the specific hooks above,
 * which subscribe to only one store and avoid unnecessary re-renders.
 */
export const useCycleDurationID = ({
  type,
}: {
  type: "admin" | "employee" | "manager"
}) => {
  const cdIdAdmin = useCycleDurationAdminID()
  const cdIdEmp = useCycleDurationEmpID()
  const cdIdManager = useCycleDurationManagerID()

  if (type === "admin") return cdIdAdmin
  if (type === "employee") return cdIdEmp
  if (type === "manager") return cdIdManager
  return null
}
